import React from 'react'
import styled, { keyframes } from 'styled-components'

const rotate = keyframes`
    0% { transform: rotate(0deg); }
    100% {transform: rotate(360deg); }
`

const alive = keyframes`
    0% {
      transform: translateY(0) rotate(0);
    }
    20% {
      transform: translateY(-5px) rotate(-10deg);
    }
    30% {
      transform: translateY(5px) rotate(10deg);
    }
    50% {
      transform: translateY(-5px) rotate(-5deg);
    }
    60% {
      transform: translateY(5px) rotate(5deg);
    }
    100% {
      transform: translateY(0) rotate(0);
    }
  }
`

const Wrapper = styled.div < { animation: string } >`
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    position: ${props => props.animation === 'rotate' ? 'absolute' : 'relative'};
    top: ${props => props.animation === 'rotate' ? '50%' : 'unset'};
    left: ${props => props.animation === 'rotate' ? '50%' : 'unset'};
    transform: ${props => props.animation === 'rotate' ? 'translate(-50%, -50%)' : 'rotate(270deg)'};
`

const StyledPokeball = styled.div < { animation: string, color: string } >`
    width: 60px;
    height: 60px;
    background-color: #fff;
    border-radius: 50% ;
    position: relative;
    overflow: hidden;
    border: 3px solid;
    animation: ${props => props.animation === 'rotate' ? rotate : alive};
    animation-duration: ${props => props.animation === 'rotate' ? '.8s' : '1.25s'};
    animation-timing-function: linear;
    animation-delay: 0s;
    animation-iteration-count: infinite;
    animation-play-state: ${props => (props.animation.length > 0) ? 'running' : 'paused'};

    @media (max-width: 768px) {
        width: 40px;
        height: 40px;
    }

    @media (max-width: 480px) {
        width: 30px;
        height: 30px;
    }

    &::after {
        content: '';
        position: absolute;
        width: 60px;
        height: 63px;
        background-color: ${props => props.color};
        border-bottom: 4px solid;
        top: -4px
    }

    &::before {
        content: '';
        position: absolute;
        background-color: #fff;
        width: 10px;
        height:10px;
        border: 4px solid;
        border-radius: 50%;
        bottom: 21px;
        right: 21px;
        z-index: 1;

        @media (max-width: 768px) {
            width: 8px;
            height: 8px;
            bottom: 12px;
            right: 12px;
        }

        @media (max-width: 480px) {
            width: 6px;
            height: 6px;
            bottom: 8px;
            right: 8px;
        }
    }
`

interface PokeBallProps {
  animation?: string
  color: string
}

const PokeBall = ({ animation, color }: PokeBallProps): JSX.Element => {
  return (
    <Wrapper animation={animation ?? ''}>
        <StyledPokeball animation={animation ?? ''} color={color}/>
    </Wrapper>
  )
}

export default PokeBall
